// 设置相关的类型定义
import { AudioFrameConstants } from '../constants/AudioFrameConstants';

export interface NetworkSettings {
  // WebSocket配置
  reconnectInterval: number; // 重连间隔（毫秒）
  maxReconnectAttempts: number; // 最大重连次数
  pingInterval: number; // 心跳包间隔（毫秒）
  connectionTimeout: number; // 连接超时时间（毫秒）
}

export interface AudioSettings {
  // 音频配置
  sampleRate: number; // 采样率
  channels: number; // 声道数
  bufferSize: number; // 缓冲区大小
  defaultVolume: number; // 默认音量 (0-1)
  
  // 音频设备配置
  inputDeviceId: string; // 音频输入设备ID
  outputDeviceId: string; // 音频输出设备ID
  
  // 麦克风配置
  echoCancellation: boolean; // 回声消除
  noiseSuppression: boolean; // 噪声抑制
  autoGainControl: boolean; // 自动增益控制
  /** 上行 MIC 线性增益（1=原音量；未设置时按平台默认） */
  uplinkMicGain?: number;
}

export interface DeviceMonitoringSettings {
  // 设备监控配置
  statusQueryInterval: number; // 状态查询间隔（毫秒）
  statusValidationInterval: number; // 状态验证间隔（毫秒）
  bufferMonitoringInterval: number; // 缓冲区监控间隔（毫秒）
}

export interface PttSettings {
  // PTT配置
  connectionTimeout: number; // 连接超时时间（毫秒）
  retryAttempts: number; // 重试次数
  retryDelay: number; // 重试延迟（毫秒）
}

export interface SystemSettings {
  network: NetworkSettings;
  audio: AudioSettings;
  deviceMonitoring: DeviceMonitoringSettings;
  ptt: PttSettings;
}

// 默认配置
export const DEFAULT_SETTINGS: SystemSettings = {
  network: {
    reconnectInterval: 3000,
    maxReconnectAttempts: 5,
    pingInterval: 30000,
    connectionTimeout: 10000
  },
  audio: {
    sampleRate: AudioFrameConstants.SAMPLE_RATE,
    channels: AudioFrameConstants.CHANNELS,
    bufferSize: AudioFrameConstants.MIN_PACKET_SIZE, // 使用常量
    defaultVolume: 0.5,
    inputDeviceId: 'default', // 默认输入设备
    outputDeviceId: 'default', // 默认输出设备
    echoCancellation: true,
    noiseSuppression: false,
    autoGainControl: false
  },
  deviceMonitoring: {
    statusQueryInterval: 5000,
    statusValidationInterval: 5000,
    bufferMonitoringInterval: 1000
  },
  ptt: {
    connectionTimeout: 10000,
    retryAttempts: 3,
    retryDelay: 1000
  }
};

// 设置选项
export const SAMPLE_RATE_OPTIONS = [
  { value: 8000, label: '8000 Hz' },
  { value: 16000, label: '16000 Hz' },
  { value: 22050, label: '22050 Hz' },
  { value: 44100, label: '44100 Hz' },
  { value: 48000, label: '48000 Hz' }
];

export const CHANNEL_OPTIONS = [
  { value: 1, label: '单声道' },
  { value: 2, label: '立体声' }
];

export const BUFFER_SIZE_OPTIONS = [
  { value: AudioFrameConstants.MIN_PACKET_SIZE, label: `${AudioFrameConstants.MIN_PACKET_SIZE} 字节` },
  { value: AudioFrameConstants.MIN_PACKET_SIZE * 2, label: `${AudioFrameConstants.MIN_PACKET_SIZE * 2} 字节` },
  { value: AudioFrameConstants.MIN_PACKET_SIZE * 4, label: `${AudioFrameConstants.MIN_PACKET_SIZE * 4} 字节` },
  { value: AudioFrameConstants.MIN_PACKET_SIZE * 8, label: `${AudioFrameConstants.MIN_PACKET_SIZE * 8} 字节` } // 增加更大的缓冲区选项
];
